module.exports = __webpack_public_path__ + "static/media/Code.57d5b4fd.svg";